export default "__VITE_ASSET__3a65fc9d__"